import React, { useState, createContext, useContext, useEffect } from 'react'
import Api from 'utils/api'
import * as authHelper from 'utils/auth-helper'
import checkSSO from 'utils/sso-handler'
import { useAuth } from './auth'

const initSSOContextPropsState = {
  sso: undefined,
  setSSO: () => {},
  isLoading: false,
}

const SSOContext = createContext(initSSOContextPropsState)

const useSSO = () => {
  return useContext(SSOContext)
}

const SSOProvider = ({ children }) => {
  const [sso, setSSO] = useState(authHelper.getSSO())
  const [isLoading, setIsLoading] = useState(false)
  const { saveAuth } = useAuth()

  const getToken = async (sso) => {
    console.log('SSO Getting Agency Tokens')
    const { response } = await Api(
      `/auth/get_agency_token?companyId=${sso.companyId}&email=${sso.email}&name=${sso.userName}`,
      'get'
    )

    if (!response) {
      setIsLoading(false)
      console.error('Error getting auth token')
      return
    }

    saveAuth(response.data)
    setIsLoading(false)
  }

  const getSSO = async () => {
    setIsLoading(true)
    const ssoString = await checkSSO()
    console.log('SSO', ssoString)
    if (ssoString) {
      const ssoJSON = JSON.parse(ssoString)
      setSSO(ssoJSON)
      authHelper.setSSO(ssoJSON)
      await getToken(ssoJSON)
    }
    setIsLoading(false)
  }

  const onLoad = () => {
    getSSO()
  }

  useEffect(onLoad, [])

  return (
    <SSOContext.Provider
      value={{
        sso,
        setSSO,
        isLoading,
      }}
    >
      {children}
    </SSOContext.Provider>
  )
}

export { SSOProvider, useSSO }
